import type { Client } from '@detect/shared';
import { api, withTenant, type PaginatedResult } from './api';
import type { WithId } from './types';

export const clientService = {
  list: (
    tenantId: string,
    params: { limit?: number; startAfter?: string } = {}
  ): Promise<PaginatedResult<WithId<Client>>> =>
    api.getPaginated<WithId<Client>>(withTenant('/clients', tenantId, params)),
};
